import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_3fshvrc7kn: FaireCollectionEntity = {
  token: "pbc_3fshvrc7kn",
  type: "collection",
  name: "Summer Sale!",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3a848395c1955aba0ac85f7b051dbedcced5888810606bd40870d849e1288579.jpeg",
  itemCount: 92,
  description: "Stock up for the season at incredible prices!",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:14.229Z",
    importedBy: "entity-db-import-collections",
  },
};
